<template>
  <div class="px-2 pb-2 grey lighten-3 d-flex flex-column" style="height: 100%">
    
    <!-- header -->
    <div v-if="$slots.header || back" class="white mx-n2 px-2 py-1 mb-2">
      <div class="d-flex align-center">
        <slot name="header"></slot>
        <div v-if="back"
          class="ml-auto mr-2 d-flex align-center green--text text--darken-2 text-subtitle-2" 
          @click="back_action"
        >
          <v-icon small color="green darken-2">mdi-chevron-left</v-icon>
          Back
        </div>
      </div>
    </div>

    <!-- body -->
    <div class="flex-grow-1" style="overflow-y: auto;">
      <slot>
        <div class="pa-2 white rounded-lg">
          <h3 class="mb-2">Content</h3>
          Lorem ipsum dolor est...
        </div>
      </slot>
    </div>

    <!-- footer -->
    <div v-if="$slots.footer" class="mt-2 mx-n2 mb-n2 flex-grow-0">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    back: { 
      type: [Boolean, Object],
      default: () => false,
    }
  },

  computed: {
    back_action() {
      if (typeof(this.back) === 'boolean') {
        return () => this.$router.back();
      } else {
        return () => this.$router.replace(this.back)
      }
    }
  }
}
</script>
